/* istanbul ignore file */
/**
 * Created by rathompson on 9/15/21
 * File: LabelConstants
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

/**
 * CAUTION: Please make sure put LABEL as prefix when you put the constants for Label
 * LABELS goes here
 */
export const LABEL_IDENTITIES_SUBTENANT = 'Access Management for'
export const LABEL_IDENTITY_ADDRESS = 'Identity Address'
export const LABEL_ADD_NEW_IDENTITY = 'Add New Identity ({0})'
export const LABEL_IDENTITY_TYPE = 'Identity Type'
export const LABEL_DISPLAY_NAME = 'Display Name'
export const LABEL_DISPLAY_NAME_OPTIONAL = 'Display Name (Optional)'
export const LABEL_VIEW_IDENTITY = 'View Identity ({0})'
export const LABEL_TYPE_USER = 'User'
export const LABEL_TYPE_SERVICE_ACCOUNT = 'Service Account'
export const LABEL_TYPE_GROUP = 'User Group'
export const LABEL_HEADER_SUBTITLE = 'Select a row to view or remove access'
export const LABEL_OPTIONAL = 'Optional'
export const LABEL_EDIT_ACCOUNT = 'Edit Account ({0})'
export const LABEL_NAME = 'Name'
export const LABEL_DESCRIPTION = 'Description'
export const LABEL_DESCRIPTIONS = 'Descriptions'
export const LABEL_DESCRIPTION_OPTIONAL = 'Description (Optional)'
export const LABEL_FIRST_NAME = 'First Name'
export const LABEL_LAST_NAME = 'Last Name'
export const LABEL_MORE_INFO = 'More information'
export const LABEL_PILL_INPUT_PLACEHOLDER = 'username@paloaltonetworks.com'

/**
  * CAUTION: Please make sure put BUTTON as prefix when you put constants specific to button
  * Buttons goes here
  */
export const BUTTON_ADD_NEW_IDENTITY = 'Add New Identity'
export const BUTTON_REMOVE = 'Remove'
export const BUTTON_ADD = 'Add'
export const BUTTON_ASSIGN_ROLES = 'Assign Roles'
export const BUTTON_CANCEL = 'Cancel'
export const BUTTON_NEXT = 'Next'
export const BUTTON_BACK = 'Back'
export const BUTTON_DOWNLOAD_CSV = 'Download CSV File'
export const BUTTON_RESET_CLIENT_SECRET = 'Reset Client Secret'
export const BUTTON_DELETE = 'Delete'
export const BUTTON_RESET = 'Reset'
export const BUTTON_ADD_CUSTOM_ROLE = 'Add Custom Role'
export const BUTTON_CLOSE = 'Close'
export const BUTTON_DOWNLOAD_SP = 'Download SP Metadata'
export const BUTTON_ADD_IDP = 'Add Identity Provider'
export const BUTTON_ADD_DOMAIN = 'Add Domain'
export const BUTTON_SAVE = 'Save'
export const BUTTON_ADD_PERMISSIONS = 'Add Permissions'
export const BUTTON_ADD_ANOTHER = 'Add Another'
export const BUTTON_ASSIGN_ROLE = 'Assign Role'
export const BUTTON_SEND_INVITE = 'Send Invite'
export const BUTTON_DONE = 'Done'
export const BUTTON_SUBMIT = 'Submit'
export const BUTTON_FINISH = 'Finish'
export const BUTTON_PREVIOUS = 'Previous'
export const BUTTON_CONFIGURE_IDP = 'Configure Identity Provider'
export const BUTTON_CONTINUE = 'Continue'
export const BUTTON_REMOVE_ROLES = 'Remove Roles'
export const BUTTON_ADD_ROLES = 'Add Roles'
export const BUTTON_ADD_IDENTITY = 'Add Identity'
export const BUTTON_ADD_NEW = 'Add New'

/**
  * ALL FORM ITEMS
  */
export const PLACEHOLDER_IDENTITY_ADDRESS = 'identity@company.com'
export const PLACEHOLDER_SEARCH = 'Search for identities'
export const PLACEHOLDER_SERVICE_ACCOUNT_NAME = 'account-1'
export const PLACEHOLDER_CLIENT_SECRET = '****************'
export const PLACEHOLDER_CLIENT_ID = '1234-1234-1234-1234'
export const PLACEHOLDER_SERVICE_ACCOUNT_DESCRIPTION = 'Add a description about this service account'
export const PLACEHOLDER_FIRST_NAME = 'First Name'
export const PLACEHOLDER_LAST_NAME = 'Last Name'
export const PLACEHOLDER_DOMAIN_INFORMATION = 'company.com'
export const PLACEHOLDER_SAML_CONFIGURE_GET_URL = 'Enter URL'
export const PLACEHOLDER_SAML_CONFIGURE_CLOUD_IDP = 'Choose identity federation'
export const PLACEHOLDER_SAML_METADATA_ID = 'Enter the Identity Provider ID'
export const PLACEHOLDER_SAML_LOGIN_URL = 'Enter the Identity Provider Login URL'
export const PLACEHOLDER_SAML_SSO_URL = 'Enter Provider SSO URL'
export const PLACEHOLDER_ADD_OWNERS_INPUT = 'username@company.com'
export const PLACEHOLDER_ROLE_DISPLAY_NAME = 'Custom Role'

export const DOMAIN_MAX_LENGTH = 50
export const ERROR_INVALID_DOMAIN = 'Please enter a valid domain.'
export const ERROR_INVALID_DOMAIN_LENGTH = 'Domain must be less than 50 characters.'
export const ERROR_INVALID_USED_DOMAIN = 'Domain already part of federations.'
export const ERROR_INVALID_EMAIL = 'Please enter a valid email address.'
export const ERROR_INVALID_URL = 'Please enter a valid url.'
export const ERROR_URL_REQUIRED = 'Url is required.'
export const ERROR_SERVER_ADD = 'There was a problem adding this identity'
export const ERROR_SERVER_REMOVE = 'There was a problem removing this identity'
export const ERROR_ACCOUNT_INVALID = 'Account name is invalid'
export const ERROR_USER_NOT_REGISTERED = 'This user is not registered'
export const ERROR_USER_NOT_PAN = 'This user is not a PAN user'
export const ERROR_ADD_OWNERS = 'There was an error adding user. Please try again later.'
export const ERROR_VALUE = 'Please enter a valid input.'
export const ERROR_TXT_RECORD = 'Unable to locate the TXT record'

/**
  * CAUTION: Identity table label constants go here
  */
export const LABEL_HEADER_TYPE = 'Type'
export const LABEL_HEADER_DISPLAY_NAME = 'Display Name'
export const LABEL_HEADER_IDENTITY = 'Identity'
export const LABEL_HEADER_APPLICATIONS = 'Applications'
export const LABEL_HEADER_ROLE = 'Role'
export const LABEL_HEADER_SCOPE = 'Scope'
export const LABEL_APPS_SERVICES_ALL = 'All Applications & Services'
export const LABEL_APPS_SERVICES = 'Apps & Services'
export const LABEL_SUPERUSER = 'MSP Superuser'
export const LABEL_INHERITED = 'Inherited From'
export const LABEL_ONLY_DISABLED = 'This access is not editable because it is the only user with access to this TSG.'
export const LABEL_INHERITED_DISABLED = 'This access is not editable because it is inherited.'
export const LABEL_IDP_DISABLED = 'This access is not editable because it is mapped from the {0} identity federation.'
export const LABEL_IDP_DISABLED_MULTIPLE = 'This access is not editable because it is mapped from multiple identity federations.'
export const LABEL_INHERITED_ANY = 'Inherited from: Any'
export const LABEL_ALL_INHERITED = 'All Inherited'

/**
  * CAUTION: Roles constants go here
  */
export const LABEL_HAS_SUPER_FOR_ALL = 'Superuser access has already been granted to all apps and services'
export const LABEL_ALREADY_SUPERUSER = 'Already have superuser access'
export const LABEL_PREDEFINED_ROLES_TITLE = 'Predefined Roles'
export const LABEL_SELECTED_ROLES_TITLE = 'Selected Roles'
export const LABEL_PREDEFINED_ROLES_SUBTITLE = 'These are roles that have been predefined'
export const LABEL_CUSTOM_ROLES_TITLE = 'Custom Roles'
export const LABEL_CUSTOM_ROLES_SUBTITLE = 'These are roles that have been created by administrators'
export const LABEL_HEADER_ROLE_NAME = 'Role Name'
export const LABEL_HEADER_CUSTOM_ROLE_NAME = 'Custom Role Name'
export const LABEL_HEADER_ROLE_ID = 'Custom Role ID'
export const LABEL_HEADER_ROLE_DESC = 'Description'
export const LABEL_HEADER_ROLE_USERS = 'Users Assigned'
export const LABEL_HEADER_ROLE_INHERITED = 'Inheritance'
export const LABEL_HEADER_ROLE_ACTIONS = 'Actions'
export const LABEL_HEADER_PERMISSION = 'Permission'
export const LABEL_ROLE_ACTION_EDIT = 'Edit'
export const LABEL_ROLE_ACTION_CLONE = 'Clone'
export const LABEL_ROLE_ACTION_DELETE = 'Delete'
export const LABEL_ROLE_ACTION_VIEW = 'View Details'
export const LABEL_VIEW_INHERITED_TITLE = '{0} permissions'
export const LABEL_DELETE_ROLE_TITLE = 'Delete Role'
export const LABEL_NUM_PERMISSIONS = '{0} permissions'
export const LABEL_DELETE_ROLE_SUBTEXT = 'You are about to delete this role. Users assigned to this role will lose permissions and access.'
export const LABEL_DELETE_ROLE_CONFIRM = 'Would you like to continue deleting this role?'
export const LABEL_ADD_CUSTOM_ROLE_TITLE = 'Add Custom Role'
export const LABEL_EDIT_CUSTOM_ROLE_TITLE = 'Edit Custom Role'
export const LABEL_NO_ASSIGNED_PERMISSIONS = 'No assigned permissions'
export const LABEL_NUM_PERMISSIONS_TITLE = '{0} permissions'
export const LABEL_NO_PERMISSIONS_ADDED = 'No permissions added'
export const TITLE_PERMISSIONS = 'Permissions'
export const TITLE_RESULTING_PERMISSIONS = 'Resulting Access Permissions'
export const LABEL_ADD_PERMISSIONS_TITLE = 'Add Permissions'
export const LABEL_SELECT_PERMISSIONS_TITLE = 'Select permissions to add to the custom role'
export const LABEL_ASSIGN_ROLES_TITLE = 'Assign Roles ({0})'
export const LABEL_SELECTED_IDENTITIES = 'Selected Identities'
export const PLACEHOLDER_ADD_ACCESS = 'Add Access'
export const PLACEHOLDER_SELECT_ROLE = 'Select a Role'
export const TOOLTIP_DELETE = 'Delete'
export const LABEL_ALL_APPS_SERVICES = 'All Apps & Services'
export const PLACEHOLDER_ROLE_NAME = 'Superuser'
export const PLACEHOLDER_ROLE_DESC = 'Enter a brief description here'
export const LABEL_ROLE_NAME = 'Name'
export const LABEL_ROLE_DESC = 'Description'
export const PLACEHOLDER_SEARCH_PERMISSION = 'Search for permission'
export const LABEL_NO_DESCRIPTION = 'No description available'
export const BUTTON_CLONE_ROLE = 'Clone a Role'
export const TITLE_CLONE_ROLE = 'Clone a Role'
export const CLONE_ROLE_DESC = 'By selecting one of the following roles, you are copying the existing role\'s permissions and creating a new role based on those permissions.'
export const LABEL_ROLES = 'Roles'
export const CLONE_ROLE_INFO = 'The permissions are set to "No access" by default. Click the icons to toggle from "No access" to "Read only" to "Read write" to modify the permissions for the custom role.'
export const BUTTON_READ_WRITE = 'Read Write'
export const BUTTON_READ_ONLY = 'Read Only'
export const BUTTON_NO_ACCESS = 'No Access'
export const HEADER_API_NAME = 'API Name'
export const HEADER_API_DESC = 'Description'
export const ERROR_ROLE_NAME_INVALID = 'Name is invalid. Only letters and underscores are allowed. Max 16 characters.'
export const ERROR_ROLE_LABEL_INVALID = 'Display name is invalid'
export const ERROR_ROLE_DESC_INVALID = 'Description is invalid. Max 255 characters.'
export const ERROR_ROLE_EXISTS = 'Role "{0}" already exists'
export const TOOLTIP_WEB_PERMISSION = 'This permission is not editable because it’s being defined by Web UI permissions.'
export const LABEL_ROLE_DELETED = 'Role "{0}" successfully deleted.'
export const LABEL_NO_PERMISSIONS = 'This role has no permissions assigned to it'
export const TOOLTIP_INHERITED_DELETE = 'Inherited role cannot be removed.'
export const TOOLTIP_INHERITED_SERVICE_ACCOUNT_DELETE = 'Inherited service account cannot be removed.'
export const TOOLTIP_HIGHLANDER_SUPERUSER = 'Last Superuser in TSG cannot be removed.'
export const TOOLTIP_SELECTED_INHERITED_POLICY = 'You selected an inherited role which cannot be removed.'
export const TOOLTIP_SELECTED_LAST_SUPERUSER = 'Last Superuser in TSG cannot be removed.'
export const TOOLTIP_READ_ONLY = 'You do not have write access in this TSG.'
export const TOOLTIP_SCOPED_POLICY = 'Scoped roles cannot be deleted'
export const ERROR_PERMISSIONS_REQUIRED = 'Permissions are required'
/**
  * CAUTION: IDP constants go here
  */
export const TAB_DOMAINS = 'Domains'
export const LABEL_PROVIDERS_TITLE = 'Identity Federations'
export const LABEL_LOGIN_URL = 'Login URL'
export const LABEL_ASSERTION_URL = 'Assertion Consumer Service URL'
export const LABEL_AUDIENCE_URL = 'Audience URL'
export const LABEL_ENABLED = 'Enabled'
export const LABEL_DISABLED = 'Disabled'
export const LABEL_UPDATING = 'Updating Status...'
export const LABEL_ASSOCIATED_DOMAINS = 'Associated Domains'
export const LABEL_HEADER_NAME = 'Name'
export const LABEL_HEADER_DOMAIN = 'Domain'
export const LABEL_HEADER_STATUS = 'Status'
export const LABEL_HEADER_ACTIONS = 'Actions'
export const LABEL_DOMAINS_TITLE = 'Domains'
export const LABEL_DOMAINS_SUBTITLE = 'These are a list of domains'
export const TITLE_ADD_SAML = 'Add SAML Identity Provider'
export const TITLE_CONFIG_SAML = 'Configure SAML Identity Provider Profile'
export const LABEL_SAML_DESC = 'Enter a Profile Name, select your IDP vendor, and select the method you want to use to provide the metadata.'
export const LABEL_PROFILE_NAME = 'Profile Name'
export const PLACEHOLDER_PROFILE_NAME = 'Enter profile name'
export const LABEL_IDP_VENDOR = 'IDP Vendor'
export const PLACEHOLDER_IDP_VENDOR = 'Choose a vendor'
export const VENDOR_AZURE = 'Azure'
export const VENDOR_GOOGLE = 'Google'
export const VENDOR_OKTA = 'Okta'
export const LABEL_ADD_METADATA = 'Add Metadata'
export const LABEL_METADATA_DESC = 'The metadata for the IdP can be provided using a file or URL (both available from your IdP). Alternatively, you can provide the metadata manually in the fields below.'
export const BUTTON_CHOOSE_FILE = 'Choose File'
export const BUTTON_GET_URL = 'Get URL'
export const PLACEHOLDER_ENTER_URL = 'Enter URL'
export const LABEL_ENTER_URL = 'Enter URL'
export const LABEL_IDP_CERT = 'Identity Provider Certificate'
export const BUTTON_UPLOAD_CERT = 'Upload Certificate'
export const LABEL_IDP_ID = 'Identity Provider ID'
export const LABEL_IDP_CONFIG_TYPE = 'SAML2'
export const PLACEHOLDER_IDP_ID = 'Enter Identity Provider ID'
export const LABEL_IDP_LOGIN_URL = 'Identity Provider Login URL'
export const LABEL_IDP_SSO_URL = 'Identity Provider SSO URL'
export const PLACEHOLDER_IDP_SSO_URL = 'Enter Provider SSO URL'
export const LABEL_HTTP_BINDING = 'HTTP Binding for SSO Request  to IDP'
export const RADIO_HTTP_REDIRECT = 'HTTP Redirect'
export const RADIO_HTTP_POST = 'HTTP Post'
export const LABEL_MAX_CLOCK_SKEW = 'Maximum Clock Skew (Seconds)'
export const PLACEHOLDER_MAX_CLOCK_SKEW = 'Enter Maximum Clock Skew'
export const LABEL_MAX_CLOCK_SKEW_DESC = 'Enter the allowed difference in seconds between the system times of the IdP and the firewall at the moment when the firewall validates IdP messages.'
export const LABEL_CONFIRM_MFA = 'Confirm if MFA is enabled'
export const TOGGLE_MFA = 'MFA is enabled'
export const TOOLTIP_MFA = 'If MFA is enabled on your IDP, select this option to ensure CAS detects MFA in the SAML response.'
export const STEP_IDP = 'Configure IDP'
export const STEP_TEST_SAML = 'Test SAML and Attributes'
export const LABEL_OR = 'Or'
export const LABEL_URL = 'Url'
export const TITLE_TEST_SAML = 'Test SAML and Attributes'
export const TITLE_SAML_ATTRIBUTES = 'SAML Attributes'
export const LABEL_TEST_SAML_DESC = 'Test SAML authentication with the identity provider and then fill in the SAML attributes.'
export const LABEL_SAML_ATTR_DESC = 'Map your IDP SAML attributes after test is complete.'
export const LABEL_EMAIL = 'Email'
export const BUTTON_TEST_SAML = 'Test SAML'
export const ERROR_SAML_TEST_FAILED = 'Test failed. Check your IDP setup and try again.'
export const STEP_DOMAIN_INFO = 'Domain Information'
export const STEP_VERIFY_INSTRUCTIONS = 'Instructions for Verification'
export const STEP_ADDITIONAL_OWNERS = 'Additional Owners'
export const TITLE_DOMAIN_INFO = 'Domain Information'
export const LABEL_DOMAIN = 'Domain'
export const LABEL_DOMAIN_NAME_DESC = 'The display name can be customized after entering the domain name.'
export const LABEL_DOMAIN_NOT_VERIFIED = 'The domain has not be verified yet. Please go to the next step "Instructions for Verification" to learn how to complete the domain verification process.'
export const TITLE_VERIFY_INSTRUCTIONS = 'Instructions for Verification'
export const INSTRUCTIONS_SUBTEXT_1 = 'You can verify ownership of a property at the domain level by adding a DNS record in your domain name provider.'
export const INSTRUCTIONS_SUBTEXT_2 = 'To use this method, you must sign into your domain name provider (for example, GoDaddy.com or networksolutions.com) and add a new TXT record. Palo Alto Networks will verify that your personal record is present and assigned to your domain. Each DNS record associates a specific org with a specific domain.'
export const INSTRUCTIONS_SUBTEXT_3 = 'When asked to verify your property, choose the Domain verification method (or create a Domain property) and you will be given a string value to use in the next step.'
export const INSTRUCTIONS_SUBTEXT_4 = 'Add your TXT record from step 1 to your domain provider’s records.'
export const INSTRUCTIONS_SUBTEXT_5 = 'After adding your TXT record and clicking "Finish" you will be able to verify this domain. To stay verified, don\'t remove the DNS record, even after verification succeeds.'
export const LABEL_INSTRUCTIONS_1 = '1) Get your TXT record'
export const LABEL_INSTRUCTIONS_2 = '2) Add the TXT record to your domain provider'
export const TITLE_ADDITIONAL_OWNERS = 'Additional Owners'
export const LABEL_CONFIGURATION_BANNER = 'Configure your identity provider to finish set up.'
export const STEP_CONFIGURE = 'SAML Configure Method'
export const STEP_PROVIDE_SAML = 'Provide SAML Metadata'
export const TITLE_CONFIGURE_IDP = 'Configure Identity Provider'
export const TITLE_EDIT_CONFIGURE_IDP = 'Edit Identity Provider'
export const TITLE_IDP_SAML = 'SAML Configure Method'
export const SAML_INSTRUCTIONS_SUBTEXT_1 = 'Select the method you want to use to provide the metadata'
export const SAML_INSTRUCTIONS_SUBTEXT_2 = 'The metadata for the IdP can be provided using a file or URL (both available from your IdP). Alternatively, you can provide the metadata manually in the fields on the next page or clone an IdP configuration.'
export const PLACEHOLDER_CHOOSE_IDENTITY_FEDERATION = 'Enter URL'
export const LABEL_SAML_CONFIGURE_DESC = 'To configure quickly, you can clone an IdP configuration from an existing identity federation.'
export const LABEL_ENTER_MANUALLY = 'Enter Manually'
export const LABEL_UPLOAD_METADATA = 'Upload Metadata'
export const LABEL_GET_URL = 'Get URL'
export const LABEL_CLONE_IDP_CONFIG = 'Clone IdP Configuration'
export const HEADING_HAS_NO_FEDERATIONS = 'No Identity Federations'
// TODO: lorem ipsum should be deleted/replaced
export const DESC_HAS_NO_FEDERATIONS = 'Add identity federations.'
export const CERTIFICATE_SUCCESS_UPLOADED = 'Certificate succesfully uploaded.'
export const SUCCESS_DATA_UPLOADED = 'Successfully uploaded data.'
export const ERROR_IDP_UPLOAD = 'There was an error with the upload. Please verify information.'
export const ERROR_METADATA_UPLOAD = 'There was an error with the upload. Please verify content of file is in correct format.'
export const ERROR_URL_METADATA = 'There was an error. Please verify link.'
export const ERROR_VERIFY = 'Unable to locate the TXT record. Make sure that the provided string is set up correctly.'
export const ERROR_CERTIFICATE_REQUIRED = 'Valid certificate required.'
export const ERROR_GENERIC = 'An error occurred. Please try again.'
export const SUCCESS_GENERIC = 'Success!'
export const SUCCESS_VERIFIED = 'Successfully verified'
export const SUCCESS_DOWNLOAD = 'Downloaded Successfully!'
export const BUTTON_VIEW_INSTRUCTIONS = 'View Instructions'
export const BUTTON_DISABLE = 'Disable'
export const BUTTON_ENABLE = 'Enable'
export const BUTTON_VERIFY = 'Verify Now'
export const BUTTON_EDIT = 'Edit'
export const LABEL_DELETE_FEDERATION = 'You are about to remove “{0}”. Are you sure you want to continue?'
export const LABEL_DELETE_OWNER = 'You are about to remove {0}. Are you sure you want to continue?'
export const LABEL_DELETE_OWNER_DNS_TEXT = 'Please ensure that you have removed your verification string from your TXT record.'
export const LABEL_DELETE_FEDERATION_DNS_TEXT = 'Please check that all verification strings have been removed from your TXT record.'
export const TAB_OWNERS = 'Owners'
export const TAB_MAPPING = 'Tenant Mapping for Authorization'
export const TAB_FEDERATION_HISTORY = 'History'
export const BUTTON_EDIT_FED_MAP = 'Edit Tenant Mapping for Authorization'
export const LABEL_ENTITY_ID = 'Entity ID'
export const LABEL_BINDING = 'Binding'
export const HEADER_TENANT_MAPPING = 'Select which tenants will map its users to the identity federation users:'
export const SUBTEXT_TENANT_MAPPING = 'Note: Users will only receive access when the identity provider sends the user-specific role mapping information. '
export const TITLE_TENANT_MAPPING = 'Tenant Mapping for Authorization'

/**
  * CAUTION: Remove identity modal label constants go here
  */
export const LABEL_REMOVE_IDENTITY = 'Remove Identity'
export const LABEL_REMOVE_MANY = 'You are about to remove the following {0} identities'
export const LABEL_REMOVE_SINGLE = 'You are about to remove the identity "{0}"'
export const LABEL_REMOVE_CONFIRM = 'Are you sure you want to remove this identity?'
export const LABEL_REMOVE_ROLE = 'Remove Role'
export const LABEL_REMOVE_LAST_ROLE = 'This will remove the identity "{0}" from {1}'

/**
  * CAUTION: Add identity modal label constants go here
  */
export const LABEL_IDENTITY_INFORMATION = 'Identity Information'
export const LABEL_CLIENT_CREDENTIALS = 'Client Credentials'
export const LABEL_ASSIGN_ROLES = 'Assign Roles'
export const LABEL_SERVICE_ACCT_NAME = 'Service Account Name'
export const LABEL_SERVICE_ACCT_EMAIL = 'Identity Email'
export const LABEL_SERVICE_ACCT_CONTACT = 'Service Account Contact'
export const LABEL_SERVICE_ACCT_CONTACT_OPT = 'Service Account Contact (Optional)'
export const LABEL_CREDENTIAL_NAME = 'Credential Name'
export const LABEL_CREDENTIAL_EXPIRES = 'Credential Expiration'
export const LABEL_CLIENT_ID = 'Client ID'
export const LABEL_CLIENT_SECRET = 'Client Secret'
export const LABEL_ENABLE_EXPIRATION = 'Enable Expiration'
export const LABEL_APPS_AND_SERVICES = 'Apps & Services'
export const LABEL_ROlE = 'Role'
export const LABEL_SCOPE = 'Scope'
export const LABEL_CREDENTIAL_NAME_SUBTEXT = 'Enter a meaningful name for the credential name. As a best practice, set an expiration date and rotate the key frequently.'
export const LABEL_CLIENT_SECRET_MESSAGE = 'Please save the "Client Secret", you will not be able to copy it after saving the new identity.'
export const LABEL_CLIENT_SECRET_RESET_MESSAGE = 'If you lose your client secret, you can reset it.'
export const LABEL_RESET_CLIENT_SECRET_TITLE = 'Reset Client Secret'
export const LABEL_RESET_CLIENT_SECRET_MSG = 'Resetting the client secret will break any existing applications and integrations using this service account.'
export const LABEL_RESET_CLIENT_SECRET_CONFIRM = 'Would you like to continue to reset the client secret?'
export const LABEL_SEND_INVITE = 'This user is not registered. Please invite the user to register and set their own password.'
export const LABEL_INVITE_SENT = 'Invitation sent.'
export const LABEL_DNS_VERIFICATION = 'DNS Verification'
export const LABEL_OWNER_GRANT = 'Owner Grant'
export const LABEL_IDENTITY_INFORMATION_AND_ROLES = 'Identity Information and Roles'

/**
  * CAUTION: Service account name rules
  */
export const LABEL_SERVICE_ACCOUNT_RULES = 'Your account name must meet the following criteria:'
export const LABEL_SERVICE_ACCOUNT_RULE_1 = 'Cannot be greater than 64 characters'
export const LABEL_SERVICE_ACCOUNT_RULE_2 = 'Cannot start or end with a dot (.) or contain consecutive dots'
export const LABEL_SERVICE_ACCOUNT_RULE_3 = 'Cannot include spaces'
export const LABEL_SERVICE_ACCOUNT_RULE_4 = 'The following characters are not allowed: '

export const MESSAGE_MULTI_IDENTITIES_REMOVED = '{0} users have been removed.'
export const MESSAGE_SINGLE_IDENTITY_REMOVED = '{0} has been removed'

/**
  * CAUTION: Add Owners modal label constants go here
  */
export const LABEL_OWNERS_DESC = 'Add additonal owners for this domain who will be able to manage the domain and IdPs.'
export const LABEL_OWNERS = 'Owners'
export const TITLE_ADD_OWNER = 'Add Owners'
export const BUTTON_ADD_OWNER = 'Add Owners'

/**
  * CAUTION: Delete Modal label constants go here
  */
export const TITLE_DELETE_FEDERATION = 'Delete Identity Federation'
export const TITLE_DELETE_OWNER = 'Delete Owner'

/**
  * CAUTION: Identity Federations Table and Card constants go here
  */
export const LABEL_OWNERS_TABLE_TITLE = 'Owners'
export const LABEL_OWNERS_TABLE_SUBTITLE = 'These are a list of the identity federation owners.'
export const LABEL_OWNERS_TABLE_HEADER_NAME = 'Name'
export const LABEL_OWNERS_TABLE_HEADER_TYPE = 'Type'
export const LABEL_OWNERS_TABLE_HEADER_STATUS = 'Status'
export const LABEL_OWNERS_TABLE_HEADER_ACTIONS = 'Actions'
export const LABEL_OWNERS_STATUS_VERIFIED = 'Verified'
export const LABEL_OWNERS_STATUS_WARNING = 'Verified Warning'
export const LABEL_OWNERS_STATUS_PENDING = 'Pending Verification'
export const LABEL_OWNERS_STATUS_NA = 'N/A'
export const LABEL_OWNERS_ACTION_VERIFY = 'Verify Now'
export const LABEL_OWNERS_ACTION_VERIFY_INSTRUCTIONS = 'View Verification Instructions'
export const LABEL_OWNERS_ACTION_DELETE = 'Delete'
export const TITLE_ADD_IDENTITY_FEDERATIONS = 'Add New Identity Federation'
export const LABEL_OWNERS_TYPE_DNS_TXT = 'dns_txt'
export const LABEL_OWNERS_TYPE_OWNER_GRANT = 'owner_grant'
export const LABEL_INACTIVE_IDP = 'IDP has not been activated in Okta'

